import React, { useState } from 'react';
import { Dropdown } from '@instinet-analytics/semantic-ui-components';
import { DropdownItemProps } from '@instinet-analytics/semantic-ui-components';

export interface WidgetDropdownEditorProps<
    TConfig,
    TKey extends keyof TConfig,
> {
    options: DropdownItemProps[];
    className?: string;
    propertyName: TKey;
    config: TConfig;
    label: string;
    onChange: (delta: Partial<TConfig>) => void;
    onDisplayValueChange?: (value: TConfig[TKey]) => void;
}

export default function WidgetSettingsDropdownEditor<
    TConfig,
    TKey extends keyof TConfig,
>(props: WidgetDropdownEditorProps<TConfig, TKey>) {
    const {
        className,
        config,
        onChange,
        propertyName,
        label,
        options,
        onDisplayValueChange,
    } = props;
    const configValue = config[propertyName];

    const [value, setValue] = useState(configValue);

    const onDropdownChanged = (dropdownValue: string | number) => {
        const nextValue = dropdownValue as unknown as TConfig[TKey];

        setValue(nextValue);

        onDisplayValueChange && onDisplayValueChange(nextValue);

        const delta = {
            [propertyName]: nextValue,
        } as unknown as Partial<TConfig>;
        onChange(delta);
    };

    return (
        <div>
            <div>{label}</div>
            <Dropdown
                className={className}
                onChange={onDropdownChanged}
                value={value as unknown as string}
                options={options}
            />
        </div>
    );
}
